  // DT Cart Popup Handler
  (function() {
    // Wait for DOM and theme to be ready
    function initDTPopupHandler() {
      if (typeof theme === 'undefined' || !theme.Modals) {
        setTimeout(initDTPopupHandler, 100);
        return;
      }

      function getLiveBSDTTags(tagsInput) {
        if (!tagsInput) {
          return []; // untagged product
        }
        // Normalize tags and check against theme's BS_DT parser using theme.liquid:dtParseTags
        if (typeof dtParseTags !== 'function') {
          console.error('[dt-cart-popup] dtParseTags is not defined (layout/theme.liquid)');
          return [];
        }

        var normalized = Array.isArray(tagsInput)
          ? tagsInput.join(', ')
          : (tagsInput.toString ? tagsInput.toString() : '');

        var parsed = dtParseTags(normalized);
        if (!Array.isArray(parsed)) {
          return [];
        }

        return parsed.filter(function(tag) {
          // console.log(`dt-cart-popup getLiveBSDTTags`, {
          //   tag,
          //   isLive: tag.isLive,
          //   isBsDt: tag.isBsDt,
          // })
          return tag && tag.isLive && tag.isBsDt;
        });
      }

      function updateCartInfo() { // Update cart info in popup (placeholder for future logic)
        var itemCountEl = document.getElementById('dt-popup-item-count');
        var cartTotalEl = document.getElementById('dt-popup-cart-total');

        if (itemCountEl) {
          itemCountEl.textContent = '0'; // Placeholder
        }

        if (cartTotalEl) {
          cartTotalEl.textContent = '0'; // Placeholder
        }

        // Future: Fetch cart data and update
        theme.cart.getCart().then(function(cart) {
          if (itemCountEl) {
            itemCountEl.textContent = cart.item_count || 0;
          }
          if (cartTotalEl) {
            cartTotalEl.textContent = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
          }
        });
      }

      // Store modal instance
      var dtModalInstance = null;

      // Initialize DT modal
      function initDTModal() {
        if (dtModalInstance) {
          return dtModalInstance;
        }

        var popup = document.getElementById('DTCartPopup');
        if (!popup) {
          return null;
        }

        // Initialize modal
        dtModalInstance = new theme.Modals('DTCartPopup', 'dt-cart-popup', {
          close: '.js-modal-close',
          openClass: 'modal--is-active',
          closingClass: 'modal--is-closing',
          bodyOpenClass: ['modal-open'],
          bodyClosingClass: 'modal-closing'
        });

        return dtModalInstance;
      }

      function hasLiveBSDT(cartItems) {
        for (var i = 0; i < cartItems.length; i++) {
          if (getLiveBSDTTags(cartItems[i].getAttribute('data-tags')).length > 0) return true;
        }
        return false;
      }

      function getMinCartTotal() {
        var popup = document.getElementById('DTCartPopup');
        var value = popup ? parseFloat(popup.getAttribute('data-min-cart-total')) : NaN;
        return isNaN(value) ? 700 : value;
      }

      // BS_DT criteria, shared by the checkout popup and the cart block (A/B bs_dt-cart-block): a live
      // BS_DT item, no discount code, and either one item or 2+ items under the market minimum (items
      // subtotal before discounts). Reads the drawer markup from templates/cart.ajax.liquid:
      // <div class="cart__item" data-key="…" data-quantity="…" data-tags="…">
      function bsdtCriteriaUnmet(form) {
        if (form.querySelector('.cart-discount-remove-btn')) {
          return false; // a discount code is applied
        }
        var cartItems = form.querySelectorAll('.cart__item');
        if (!hasLiveBSDT(cartItems)) {
          return false;
        }
        var itemsNode = form.querySelector('.cart__items');
        var cartOriginalTotalInt = itemsNode ? parseInt(itemsNode.getAttribute('data-cart-original-total'), 10) / 100 : 0;
        var totalAmountOfItemsInCart = [...cartItems].reduce(function(acc, cartItem) {
          return acc + parseInt(cartItem.getAttribute('data-quantity'), 10);
        }, 0);
        var rule1 = totalAmountOfItemsInCart === 1;
        var rule2 = totalAmountOfItemsInCart > 1 && cartOriginalTotalInt < getMinCartTotal();
        return rule1 || rule2;
      }

      // Show DT popup
      function showDTPopup() {
        // Update cart info
        updateCartInfo();

        // Initialize modal if needed
        var modal = initDTModal();

        if (modal && modal.open) {
          modal.open();
        } else {
          // Fallback: manually show modal
          var popup = document.getElementById('DTCartPopup');
          if (popup) {
            popup.style.display = 'block';
            document.documentElement.classList.add('modal-open');
            popup.classList.add('modal--is-active');
          }
        }

        if (typeof bsdt_popup_shown === 'function') {
          bsdt_popup_shown();
        }
      }

      // Close DT popup
      function closeDTPopup() {
        var modal = initDTModal();
        if (modal && modal.close) {
          modal.close();
        } else {
          // Fallback: manually close modal
          var popup = document.getElementById('DTCartPopup');
          if (popup) {
            popup.style.display = 'none';
            document.documentElement.classList.remove('modal-open');
            popup.classList.remove('modal--is-active');
          }
        }
      }


      // Intercept checkout button click in cart drawer using event delegation
      function interceptCheckoutClick() {
        // Use event delegation to handle dynamically loaded buttons
        document.addEventListener('click', function(evt) {
          var target = evt.target;

          // check if target is checkout button
          if (!target.classList.contains('cart__checkout')) {
            return
          }
          var form = target.closest('#CartDrawerForm');
          if (!form) {
            return
          }

          if (bsdtCriteriaUnmet(form)) {
            // A/B bs_dt-pop-up decision point: the call logs exposure, treatment checks out
            if (typeof window.villoidBsdtPopupVariant === 'function' && window.villoidBsdtPopupVariant() === 'treatment') {
              if (typeof bsdt_popup_not_shown === 'function') {
                bsdt_popup_not_shown();
              }
              return;
            }
            evt.preventDefault();
            evt.stopImmediatePropagation();
            showDTPopup();
          }
        }, true); // Use capture phase to intercept before other handlers
      }

      // Handle popup button clicks (only set up once)
      var popupButtonsSetup = false;
      function setupPopupButtons() {
        // Prevent duplicate event listeners
        if (popupButtonsSetup) {
          return;
        }
        popupButtonsSetup = true;

        // Shop more button - close popup and go to the configured shop-more URL
        var shopMoreBtn = document.querySelector('.dt-cart-popup__shop-more');
        if (shopMoreBtn) {
          shopMoreBtn.addEventListener('click', function() {
            closeDTPopup();
            var shopMoreUrl = shopMoreBtn.getAttribute('data-shop-more-url');
            if (shopMoreUrl) {
              window.location.href = shopMoreUrl;
            }
          });
        }

        // Go to checkout button - proceed to checkout
        var goToCheckoutBtn = document.querySelector('.dt-cart-popup__go-to-checkout');
        if (goToCheckoutBtn) {
          goToCheckoutBtn.addEventListener('click', function() {
            closeDTPopup();
            window.location.href = '/checkout';
          });
        }
      }

      // Setup checkout interception and popup buttons
      function setupCheckoutInterception() {
        // Setup event delegation for checkout button (works even if dynamically loaded)
        interceptCheckoutClick();
        setupPopupButtons();
        
        // Also listen for cart drawer opening to ensure buttons are set up
        document.addEventListener('drawer:open', function(evt) {
          if (evt.detail && evt.detail.drawerId === 'CartDrawer') {
            // Small delay to ensure DOM is updated
            setTimeout(function() {
              setupPopupButtons();
            }, 100);
          }
        });
      }

      // BS_DT cart block (A/B bs_dt-cart-block, snippets/bsdt-cart-block.liquid). Decided whenever the cart
      // drawer is on screen: when it opens, and after every rebuild while open (theme.js cartMarkup
      // refills [data-products] on quantity changes, removals and add-to-cart).
      function initCartBlock() {
        var drawer = document.getElementById('CartDrawer');
        var form = document.getElementById('CartDrawerForm');
        var block = form && form.querySelector('[data-bsdt-cart-block]');
        var products = form && form.querySelector('[data-products]');
        if (!block || !products) {
          return;
        }

        function update() {
          if (!drawer.classList.contains('drawer--is-open')) {
            return;
          }
          // A/B bs_dt-cart-block decision point: the call logs exposure, treatment sees the block
          block.hidden = !(bsdtCriteriaUnmet(form) &&
            typeof window.villoidBsdtCartBlockVariant === 'function' &&
            window.villoidBsdtCartBlockVariant() === 'treatment');
        }

        // An add-to-cart opens the drawer before its rebuild lands, so that open would decide on the
        // previous cart; the rebuild decides instead. Capture runs before theme.js opens the drawer.
        var rebuildPending = false;
        document.addEventListener('ajaxProduct:added', function() {
          rebuildPending = true;
        }, true);
        document.addEventListener('drawerOpen.CartDrawer', function() {
          if (!rebuildPending) {
            update();
          }
        });
        new MutationObserver(function() {
          rebuildPending = false;
          update();
        }).observe(products, { childList: true });
      }

      setupCheckoutInterception();
      initCartBlock();
    }

    // Start initialization
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initDTPopupHandler();
      });
    } else {
      initDTPopupHandler();
    }
  })();
